module.exports = __webpack_public_path__ + "static/img/icon_game_1.1f57b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_1.png
// module id = qevM
// module chunks = 0